<div class="card" *withPermissions="let allow of ['CanUpdateAdvancedSettings', 'CanEditActionConfiguration', 'CanResetSeoMinutes']">
  <div class="card-header">
    <span>Allocate Work</span>
    @if (allow().CanResetSeoMinutes())
    {
      <button (click)="resetSeoMinutes()" class="float-end btn btn-sm btn-primary">Reset Minutes</button>
    }
  </div>
  <div [loadingOverlay]="isLoading" class="card-body">
    <div *ngIf="seoWorkSettings() && seoWorkSettings().UnresolvedWorkOrderBlocks.length > 0" class="alert alert-warning" role="alert">
      <strong>
        <i class="fas fa-exclamation-triangle"></i>
      </strong>
      This customer has the following issues that are preventing work from being created:
      <ul>
        <li *ngFor="let $workOrderBlock of seoWorkSettings().UnresolvedWorkOrderBlocks"> {{ $workOrderBlock }}</li>
      </ul>
      Please contact <a href="mailto:ops@boostability.com">ops&#64;boostability.com</a> if you are unsure how to resolve the Work Order Validation Issue{{ seoWorkSettings().UnresolvedWorkOrderBlocks.length > 1 ? '(s)' : '' }}.
      <div>
        <button class="btn btn-info mt-3" (click)="checkWorkOrderBlocks()" [disabled]="checkingBlocks">Recheck Validation Issues</button>
      </div>
    </div>
    @if (seoWorkSettings())
    {
      <app-tab-panel [displayMode]="TabPanelDisplayMode.horizontal" [activeTab]="selectedTab" (selected)="tabChanged($event)">
        <app-lazy-tab title="Past">
          <app-components-managecustomer-past-work *tabContent
            [customer]="customer()"
            [pastWorkRequestDetails]="pastWorkRequestDetails()"
            [hasValidAccessDetails]="seoWorkSettings()?.HasValidAccessDetails"
            (editWorkRequest)="editItem($event)"
            (deleteWorkRequest)="deleteWorkRequest($event)">
          </app-components-managecustomer-past-work>
        </app-lazy-tab>
        <app-tab title="Work Planner" [error]="workPlannerErrors()?.length">
          <div *tabContent>
            @if (previewingFuture)
            {
              <app-components-managecustomer-work-preview
                [previewPeriods]="previewPeriods()">
              </app-components-managecustomer-work-preview>
            }
            @else
            {
              <app-components-managecustomer-work-planner
                [currentPeriod]="currentPeriod()"
                [futurePeriods]="futurePeriods()"
                [taskTypes]="taskTypes()"
                [customer]="customer()"
                [user]="user()"
                [periodDetails]="seoWorkSettings()?.PeriodDetails"
                (workAdded)="addItem($event.type, $event.period)"
                (workQtyUpdated)="setItemQuantity($event.type, $event.period, $event.quantity)"
                (workRemoved)="removeItem($event)"
                (editWorkRequest)="editItem($event)"
                (previewRequested)="previewFuture()"
                (stopPreview)="stopPreview()"
                (refresh)="refreshTaskTypesAndPeriodDetails()">
              </app-components-managecustomer-work-planner>
            }
          </div>
        </app-tab>
      </app-tab-panel>
    }
    @if (!previewingFuture)
    {
    <div class="form-group" [(formGroup)]="forms">
      <textarea formControlName="configurationChange" class="form-control" rows="5" [formValidation]="forms.get('configurationChange')"
        placeholder="Configuration Change Note"></textarea>
    </div>
    <div class="card card-body bg-light d-flex flex-row">
      @if (selectedTab === 'Work Planner')
      {
        <button [disabled]="isLoading" (click)="previewFuture()" class="btn btn-primary">
          <i class="fa fa-eye"></i>
          Preview Next 6 Months
        </button>
      }

      <button [disabled]="isLoading" (click)="save()" class="btn btn-success ms-auto">
        <i class="fa fa-save"></i>
        Update Configuration
      </button>
    </div>
    }
    @else
    {
      <div class="card card-body bg-light d-flex flex-row">
        <button [disabled]="isLoading" (click)="stopPreview()" class="btn btn-primary">
          <i class="fa fa-eye-slash"></i>
          Stop Preview
        </button>
      </div>
    }
  </div>
</div>